import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Img } from '../../../../hybrid/wrappers';
import { t } from '../../../../common/components/T';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import css from './Rang.module.scss';
import classnames from 'classnames';
import { generateGridStyles } from '../../components/helpers';
import Image from 'next/image';

const Rang = ({ getHandlers, val, align, translation, gridStyles, name }) => {
    const { classes, existSt } = generateGridStyles(gridStyles, name);
    const modalDropdown = useRef(false);

    const widthDimensions = useWindowDimensions();
    const isDesktop = widthDimensions > 1024;

    const iconSize = existSt('ico')?.width;

    if (isDesktop)
        return (
            <div
                {...getHandlers(false)}
                className={classnames(
                    css.rangConteiner,
                    align === 'left' ? css.rangConteinerLeft : align === 'right' ? css.rangConteinRight : {}
                )}
            >
                {
                    <div className={css.rangWrapper}>
                        {val?.preview?.url || val?.preview?.links?.preview ? (
                            <div
                                style={iconSize ? { width: iconSize, height: iconSize } : {}}
                                className={classnames(css.rangSvgBox)}
                                ref={modalDropdown}
                            >
                                <Img
                                    src={`${val ? val?.preview?.url || val?.preview?.links?.preview : 0}`}
                                    className={classes.ico}
                                    style={
                                        existSt('ico') || {
                                            width: 34,
                                            height: 34,
                                            borderRadius: '34px',
                                            overflow: 'hidden'
                                        }
                                    }
                                />
                            </div>
                        ) : (
                            <div
                                className={classnames(css.rangSvgBox, css.ico, !val?.id ? css.rangSvgBoxBg : '')}
                                ref={modalDropdown}
                            >
                                <Image
                                    className={classnames(classes.ico, `rank${val?.id || 0}`)}
                                    src={`/src/img/ranks/rank${val?.id || 0}.png`}
                                    alt={`Rank ${val?.sort || 0}`}
                                    fill
                                />
                            </div>
                        )}
                        <div className={css.rangNameText}>
                            {val?.name || t('grid-withoutRang', 'Без ранга', 'widget', translation, 'grid')}
                        </div>
                    </div>
                }
            </div>
        );
    return (
        <div
            {...getHandlers(false)}
            className={classnames(
                css.rangConteiner,
                align === 'left' ? css.rangConteinerLeft : align === 'right' ? css.rangConteinRight : {}
            )}
        >
            <div style={{ display: 'flex', position: 'relative', alignItems: 'center' }}>
                {val?.preview?.url || val?.preview?.links?.preview ? (
                    <div
                        style={iconSize ? { width: iconSize, height: iconSize } : {}}
                        className={css.rangSvgBox}
                        ref={modalDropdown}
                    >
                        <Img
                            src={`${val ? val?.preview?.url || val?.preview?.links?.preview : 0}`}
                            className={classes.ico}
                            style={
                                existSt('ico') || {
                                    width: 34,
                                    height: 34,
                                    borderRadius: '34px',
                                    overflow: 'hidden'
                                }
                            }
                        />
                    </div>
                ) : (
                    <div
                        style={iconSize ? { width: iconSize, height: iconSize } : {}}
                        className={classnames(css.rangSvgBox, css.ico, !val?.id ? css.rangSvgBoxBg : '')}
                        ref={modalDropdown}
                    >
                        <Image
                            className={classnames(classes.ico, `rank${val?.id || 0}`)}
                            src={`/src/img/ranks/rank${val?.id || 0}.png`}
                            alt={`Rank ${val?.sort || 0}`}
                            fill
                        />
                    </div>
                )}
                <div className={css.rangNameText}>
                    {val?.name || t('grid-withoutRang', 'Без ранга', 'widget', translation, 'grid')}
                </div>
            </div>
        </div>
    );
};
Rang.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string]),
    name: PropTypes.string
};
export default Rang;
